<md-page-title value="md-page-title | Page title"></md-page-title>

<div class="flex direction-column gap-4 p-3">
  <md-page-title id="all-attributes" value="the Title"></md-page-title>

  <md-page-title value="Ny søknad om forurensning -(#firma/selskapsorg navn) | Long text"></md-page-title>
</div>
